import React from "react";
import { Form, Input } from "antd";
import { LockOutlined } from "@ant-design/icons";

const UserPasswordNew = (props) => {
  // -------------------------- VAR --------------------------
  const { disabled } = props;
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- FUNCTION --------------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN --------------------------
  return (
    <Form.Item
      name="password"
      label="New Password"
      rules={[
        {
          required: true,
          message: "Please input new password",
        },
        {
          min: 6,
          message: "Min length must be at least 6 characters",
        },
      ]}
    >
      <Input.Password
        showCount
        maxLength={16}
        minLength={6}
        prefix={<LockOutlined className="form-item-icon" />}
        placeholder="Password"
        disabled={disabled}
      />
    </Form.Item>
  );
};

export default UserPasswordNew;
